//移动端整体改版后添加路由addRoutes
const HVH5Route=[
    {
        path: '/NVH5Mainroute',
        name: 'NVH5Mainroute',
        component:()=>import('@/view/web-NVH5/NVH5Home/NVH5homeMainRoute.vue'),
        children:[
            {
                path: '/NVH5Login',
                name: 'NVH5Login',
                meta: {
                  title: '登录'
                },
                component:()=>import('@/view/web-NVH5/NVH5Login/NVH5Loginindex.vue')
            },
            {
              path: '/NVH5Register',
              name: 'NVH5Register',
              meta: {
                title: '注册'
              },
              component:()=>import('@/view/web-NVH5/NVH5Register/NVH5Registerindex.vue')
            },
            {
                path: '/NVH5Aggrement',
                name: 'NVH5Aggrement',
                meta: {
                  title: '用户协议和隐私政策'
                },
                component:()=>import('@/view/web-NVH5/NVH5Aggrement/NVH5Aggrement.vue')
            },
            {
              path: '/NVH5Personalcenter',
              name: 'NVH5Personalcenter',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5UserCenter/NVH5Percenterindex.vue')
            },
            //账号资料
            {
              path: '/NVH5Accountindex',
              name: 'NVH5Accountindex',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5UserAccount/AccountDataindex.vue')
            },
            {
              path: '/NVH5Accountbindtip',
              name: 'NVH5Accountbindtip',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5UserAccount/AccountbindTip.vue')
            },
            {
              path: '/NVH5Changebind',
              name: 'NVH5Changebind',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5UserAccount/Changebind.vue')
            },
            {
              path: '/NVH5Modifypassword',
              name: 'NVH5Modifypassword',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5UserAccount/Modifypassword.vue')
            },
            {
              path: '/NVH5ForgetPassword',
              name: 'NVH5ForgetPassword',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5UserAccount/ForgetPassword.vue')
            },
            {//个人进行企业认证
              path: '/NVH5PersonalComAuth',
              name: 'NVH5PersonalComAuth',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5UserToComAuth/NVH5PersonalComAuth.vue')
            },
            {//发票和邮寄地址管理
              path: '/NVH5BillAddress',
              name: 'NVH5BillAddress',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5BillAddressMg/BillAddressIndex')
            },
            {//企业分享链接邀请成员通知
              path: '/NVH5ApplyNotice',
              name: 'NVH5ApplyNotice',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5ApplyNotice/index.vue')
            },
            {//
              path: '/NVH5HomeIndex',
              name: 'NVH5HomeIndex',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5PersonalHome/NVH5HomeIndex.vue')
            },
            {//
              path: '/NVH5Personalinfo',
              name: 'NVH5Personalinfo',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5PersonalData/NVH5Personalinfo.vue')
            },
            {//试用中心产品申请详情
              path: '/NVH5PersonalInfoEdit',
              name: 'NVH5PersonalInfoEdit',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5PersonalData/NVH5PersonalInfoEdit.vue')
            },
            {//试用申请记录
              path: '/NVH5TryputRequest',
              name: 'NVH5TryputRequest',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5Trial/NVH5TryputRequest.vue')
            },
            // {//结构2010规范V6系列设计软件详情
            //   path: '/NVH5StructureDetails',
            //   name: 'NVH5StructureDetails',
            //   meta: {
            //     title: '个人中心'
            //   },
            //   component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5Trial/NVH5StructureDetails.vue')
            // },
            {//旧版云应用详情
              path: '/NVH5OldPKPMCloudApp',
              name: 'NVH5OldPKPMCloudApp',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5Trial/NVH5OldPKPMCloudApp.vue')
            },
            {//试用中心产品列表
              path: '/NVH5TrialCenter',
              name: 'NVH5TrialCenter',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5Trial/NVH5TrialCenter.vue')
            },
            {//试用中心产品详情
              path: '/NVH5TrialCenterProDerail',
              name: 'NVH5TrialCenterProDerail',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5Trial/NVH5TrialCenterProDerail.vue')
            },
            {//试用中心产品申请详情
              path: '/NVH5TrialApplyResult',
              name: 'NVH5TrialApplyResult',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5Trial/NVH5TrialApplyResult.vue')
            },
            
            {//试用申请补充个人信息
              path: '/NVH5TrialaddInfo',
              name: 'NVH5TrialaddInfo',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5Trial/NVH5TrialaddInfo.vue')
            },
            {//会议试用介绍
              path: '/NVH5MeetingIntroduce',
              name: 'NVH5MeetingIntroduce',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5Meeting/NVH5MeetingIntroduce.vue')
            },
            {//会议试用补全个人信息
              path: '/NVH5MeetingAddPersonInfo',
              name: 'NVH5MeetingAddPersonInfo',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5Meeting/NVH5MeetingAddPersonInfo.vue')
            },
            {//会议试用申请结果页面
              path: '/NVH5MeetingApplyResult',
              name: 'NVH5MeetingApplyResult',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5Meeting/NVH5MeetingApplyResult.vue')
            },
            {//消息提醒
              path: '/NVH5MessageCenter',
              name: 'NVH5MessageCenter',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5MessageCenter/NVH5Messageindex.vue')
            },
            {//消息详情
              path: '/NVH5MessageDetail',
              name: 'NVH5MessageDetail',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5MessageCenter/NVH5MessageDetail.vue')
            },
            {//我的事项
              path: '/NVH5backlog',
              name: 'NVH5backlog',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5MessageCenter/NVH5backlog.vue')
            },
            {//事项详情
              path: '/NVH5backlogDetail',
              name: 'NVH5backlogDetail',
              meta: {
                title: '个人中心'
              },
              component:()=>import('@/view/web-NVH5/NVH5PersonalUser/NVH5MessageCenter/NVH5backlogDetail.vue')
            },
            {//微信登录
              path: '/H5wechatHome',
              name: 'H5wechatHome',
              meta: {
                title: '构力云账号'
              },
              component:()=>import('@/view/web-NVH5/wechatLoginAbout/H5wechatHome.vue')
            },
            {//微信绑定
              path: '/NVH5WxBindPage',
              name: 'NVH5WxBindPage',
              meta: {
                title: '账号绑定'
              },
              component:()=>import('@/view/web-NVH5/wechatLoginAbout/NVH5WxBindPage.vue')
            },
            {//微信绑定
              path: '/NVH5LoginAuthentication',
              name: 'NVH5LoginAuthentication',
              meta: {
                title: '登录鉴权'
              },
              component:()=>import('@/view/web-NVH5/NVH5Login/NVH5LoginAuthentication.vue')
            },    
        ]
    },
    //企业超级管理员功能相关
    {
      path: '/NVH5CompanyMainroute',
      name: 'NVH5CompanyMainroute',
      component:()=>import('@/view/web-NVH5/NVH5Home/NVH5CompanyMainRoute.vue'),
      children:[
        {
          path: '/NVH5ComManageindex',
          name: 'NVH5ComManageindex',
          meta: {
            title: '个人中心'
          },
          component:()=>import('@/view/web-NVH5/NVH5CompanyUser/NVH5CompanyManage/ComManageIndex.vue')
        },
        {
          path: '/NVH5companyinfo',
          name: 'NVH5companyinfo',
          meta: {
            title: '个人中心'
          },
          component:()=>import('@/view/web-NVH5/NVH5CompanyUser/NVH5CompanyManage/NVH5CompanyInfo.vue')
        },
        {
          path: '/SeeRecordHis',
          name: 'SeeRecordHis',
          meta: {
            title: '个人中心'
          },
          component:()=>import('@/view/web-NVH5/NVH5CompanyUser/NVH5CompanyManage/SeeRecordHis.vue')
        },
        {
          path: '/NVH5CompanyEdit',
          name: 'NVH5CompanyEdit',
          meta: {
            title: '个人中心'
          },
          component:()=>import('@/view/web-NVH5/NVH5CompanyUser/NVH5CompanyManage/NVH5CompanyEdit.vue')
        },
        {
          path: '/NVH5ComProAndSer',
          name: 'NVH5ComProAndSer',
          meta: {
            title: '个人中心'
          },
          component:()=>import('@/view/web-NVH5/NVH5CompanyUser/NVH5ComProAndSer/NVH5ComProAndSer.vue')
        },
        {
          path: '/NVH5DepAndMen',
          name: 'NVH5DepAndMen',
          meta: {
            title: '个人中心'
          },
          component:()=>import('@/view/web-NVH5/NVH5CompanyUser/NVH5CompanyManage/DepAndMenMgindex.vue')
        },
        {
          path: '/NVH5SeeInviteHis',
          name: 'NVH5SeeInviteHis',
          meta: {
            title: '个人中心'
          },
          component:()=>import('@/view/web-NVH5/NVH5CompanyUser/NVH5CompanyManage/NVH5SeeInviteHis.vue')
        },
        {
          path: '/NVH5ShareInvite',
          name: 'NVH5ShareInvite',
          meta: {
            title: '个人中心'
          },
          component:()=>import('@/view/web-NVH5/NVH5CompanyUser/NVH5CompanyManage/NVH5ShareInvite.vue')
        },
        {
          path: '/NVH5SeeMemberApply',
          name: 'NVH5SeeMemberApply',
          meta: {
            title: '个人中心'
          },
          component:()=>import('@/view/web-NVH5/NVH5CompanyUser/NVH5CompanyManage/NVH5SeeMemberApply.vue')
        },
        {
          path: '/NVH5ApplyDetail',
          name: 'NVH5ApplyDetail',
          meta: {
            title: '个人中心'
          },
          component:()=>import('@/view/web-NVH5/NVH5CompanyUser/NVH5CompanyManage/NVH5ApplyDetail.vue')
        },
        {
          path: '/NVH5CompanyCenter',
          name: 'NVH5CompanyCenter',
          meta: {
            title: '个人中心'
          },
          component:()=>import('@/view/web-NVH5/NVH5CompanyUser/NVH5CompanyCenter/NVH5CompanyCenter.vue')
        },
        {
          path: '/NVH5ComMessages',
          name: 'NVH5ComMessages',
          meta: {
            title: '个人中心'
          },
          component:()=>import('@/view/web-NVH5/NVH5CompanyUser/NVH5ComMessage/NVH5ComMesindex.vue')
        },
        {
          path: '/NVH5ComMesDetail',
          name: 'NVH5ComMesDetail',
          meta: {
            title: '个人中心'
          },
          component:()=>import('@/view/web-NVH5/NVH5CompanyUser/NVH5ComMessage/NVH5ComMesDetail.vue')
        },
      ]
    }
    
]
export  default HVH5Route


// WEBPACK FOOTER //
// ./src/router/nvh5route.js